<div *ngIf="message" class="banner {{ bannerStyle }}-banner">
  <i2g-icon *ngIf="icon" class="icon" [icon]="icon"> </i2g-icon>
  <span [innerHTML]="message | safe: 'html'"></span>
</div>
